var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2599_15042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9586 21.3762C32.3288 21.3762 34.2502 19.4548 34.2502 17.0846C34.2502 14.7144 32.3288 12.793 29.9586 12.793C27.5884 12.793 25.667 14.7144 25.667 17.0846C25.667 19.4548 27.5884 21.3762 29.9586 21.3762Z",
    stroke: "#095E4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3672 11.0753C18.2115 11.0753 20.5172 8.76958 20.5172 5.92534C20.5172 3.0811 18.2115 0.775391 15.3672 0.775391C12.523 0.775391 10.2173 3.0811 10.2173 5.92534C10.2173 8.76958 12.523 11.0753 15.3672 11.0753Z",
    stroke: "#095E4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8087 30.8162C24.8087 30.8162 32.0579 27.8172 34.6226 27.3829C36.7529 27.0209 38.1179 27.9723 38.9452 28.6652C39.9483 29.5132 39.6278 31.1367 38.3971 31.5814L18.1386 38.872C16.6495 39.4097 15.0156 39.327 13.5781 38.6652L1.7684 33.1326C1.1686 32.8534 0.775635 32.2433 0.775635 31.5814V22.3053C0.775635 21.2815 1.65464 20.4956 2.66809 20.599C4.63292 20.7851 7.31131 21.4573 11.0755 23.9702H18.5833C22.6371 23.9702 24.8087 27.0416 24.8087 30.8368H11.0755",
    stroke: "#095E4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2599_15042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.3102,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandIcon);
export default __webpack_public_path__ + "static/media/hand-icon.b8bee72b639c48cf9be9372bf01c8d54.svg";
export { ForwardRef as ReactComponent };